import { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { Add } from '@mint-lib/icons';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Button, PopoverAnchor } from '@mint-lib/tw-components';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { useAddRowDataContext } from '../../../../../../hooks/useAddRowDataContext.js';
import { useChosenVersionId } from '../../../../../../hooks/useChosenVersionId.js';

const AddRowButton = ({
  data,
  api,
}: CustomCellRendererProps<MediaPlan.MediaData>) => {
  const { mediaDataId, setAddRowData } = useAddRowDataContext();
  const chosenVersionId = useChosenVersionId();

  const handleClick = () => {
    if (data) {
      setAddRowData({
        mediaData: data,
        api,
      });
    }
  };

  const isReadOnly = !useIsAllowedPermission('campaignPlanningFeature:modify');

  const button = (
    <Button
      variant="text"
      size="small"
      icon
      onClick={handleClick}
      aria-label="Add rows"
      disabled={isReadOnly || !!chosenVersionId}
    >
      <Add className="h-4 w-4" />
    </Button>
  );

  if (mediaDataId === data?.id) {
    return <PopoverAnchor>{button}</PopoverAnchor>;
  }

  return button;
};

export default AddRowButton;
